export default __webpack_public_path__ + "static/media/towsonu-logo.88fbad51.png";